import { WsSelect, WsSelectObj, RelocationPrefIcon } from 'wisestep-base';

import WsFilterProps from '../models/WsFilterProps';

import WsAccordion from './WsAccordion';
const options: WsSelectObj[] = [
  {
    label: 'No Relocation',
    value: 'NoRelocation',
  },
  {
    label: 'Within State',
    value: 'WithinState',
  },
  {
    label: 'Within Country',
    value: 'WithinCountry',
  },
  {
    label: 'Anywhere',
    value: 'AnyWhere',
  },
];

const RelocationPreferenceFilter = ({ name, showAccordionIcon }: WsFilterProps) => (
  <WsAccordion
    title="Relocation Preference"
    startIcon={showAccordionIcon ? <RelocationPrefIcon /> : null}
  >
    <WsSelect name={name} selectArray={options} placeholder="Relocation Preference" />
  </WsAccordion>
);
export default RelocationPreferenceFilter;
